import { call, put, takeLatest } from 'redux-saga/effects';
import { actions } from '../actions/telephony';
import * as telephonyApi from '../api/telephony';
// Destructure the telephony actions.
export const { telephonyGetUsersByQuery, telephonyGetUsersByQuerySucceeded, telephonyGetUsersByQueryFailed, telephonyGetAllCountryCodes, telephonyGetAllCountryCodesSucceeded, telephonyGetAllCountryCodesFailed, telephonySetHold, telephonySetHoldSucceeded, telephonySetHoldFailed, telephonySetMute, telephonySetMuteSucceeded, telephonySetMuteFailed, telephonyRenewToken, telephonyRenewTokenSucceeded, telephonyRenewTokenFailed, telephonyGetAllOwnNumbers, telephonyGetAllOwnNumbersSucceeded, telephonyGetAllOwnNumbersFailed, telephonyGetDefaultNumber, telephonyGetDefaultNumberSucceeded, telephonyGetDefaultNumberFailed, telephonyGetQueryNumbers, telephonyGetQueryNumbersSucceeded, telephonyGetQueryNumbersFailed, } = actions;
// Saga
export const telephonySagas = [
    takeLatest(telephonyGetUsersByQuery.toString(), genWithPromise(telephonyApi.searchUsers, telephonyGetUsersByQuerySucceeded, telephonyGetUsersByQueryFailed)),
    takeLatest(telephonyRenewToken.toString(), genWithPromise(telephonyApi.getToken, telephonyRenewTokenSucceeded, telephonyRenewTokenFailed)),
    takeLatest(telephonyGetQueryNumbers.toString(), genWithPromise(telephonyApi.getQueryNumbers, telephonyGetQueryNumbersSucceeded, telephonyGetQueryNumbersFailed)),
    takeLatest(telephonyGetAllOwnNumbers.toString(), genWithPromise(telephonyApi.getAllNumbers, telephonyGetAllOwnNumbersSucceeded, telephonyGetAllOwnNumbersFailed)),
    takeLatest(telephonyGetDefaultNumber.toString(), genWithPromise(telephonyApi.getDefaultNumber, telephonyGetDefaultNumberSucceeded, telephonyGetDefaultNumberFailed)),
    takeLatest(telephonyGetAllCountryCodes.toString(), genWithPromise(telephonyApi.getAllCountryCodes, telephonyGetAllCountryCodesSucceeded, telephonyGetAllCountryCodesFailed)),
    takeLatest(telephonySetHold.toString(), genWithHoldMutePromise(telephonyApi.setHold, telephonySetHoldSucceeded, telephonySetHoldFailed)),
    takeLatest(telephonySetMute.toString(), genWithHoldMutePromise(telephonyApi.setMute, telephonySetMuteSucceeded, telephonySetMuteFailed)),
];
function genWithHoldMutePromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            result.meta.request = action.payload.setTo;
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
